<template>
  <v-btn :variant="getVariant" :width="getWidth" color="primary" rounded="xl" class="text-none" @click.stop="$emit('action')">
    <span :class="getColorClass">
      <slot name="prepend"/>
    </span>
    <span :class="getColorClass">
      <slot name="default"/>
    </span>
  </v-btn>
</template>

<script>
export default {
  name: 'BaseNavigationButton',
  props: ["background", "delete", "width"],
  computed: {
    getVariant() {
      return this.background ? 'flat' : 'text';
    },
    getColorClass() {
      if(this.background) {
        return 'lg-white';
      }
      else if(this.delete) {
        return 'lg-error';
      }
      else {
        return 'lg-medium text-primary';
      }
    },
    getWidth() {
      return this.width ? this.width : 'auto';
    }
  },
}
</script>